<section class="afiliados mb-5">
  <div class="row m-0 header justify-content-center text-center">
    <h1 class="title">Contratar un Arquitecto</h1>
  </div>
  <div class="row mt-3 mt-md-5 mx-3 mx-md-0">
    <div class="col-md-2 col-0"></div>
    <div class="col-12 col-md-8 justify-content-center text-center">
      <!-- Tarjetas de Afiliados starts -->

      <h2>
        ¿Tienes pensado diseñar, construir y/o remodelar un espacio para ti o tú
        empresa? Te invitamos a contratar los servicios de un ARQUITECTO
        COLEGIADO FEDERADO, con esto tendrás la certeza de llevar a cabo un
        proyecto 100% confiable.
      </h2>

      <app-tabla-arquitectos></app-tabla-arquitectos>

      <!-- Tarjetas de Afiliados ends -->
    </div>
    <div class="col-md-2 col-0"></div>
  </div>
</section>
